import React, { useState } from 'react';
import Wrapper from '../MentorShipHeaders/Wrapper';
import { useNavigate, useParams } from 'react-router-dom';
import Table from './CouncellorsTable';
import ViewCouncellor from './ViewCouncellor';

export default function () {
  let { uuid } = useParams();
  const [mode, setMode] = useState(uuid === undefined ? 'list' : 'single');
  const [action, setAction] = useState('view');
  let navigate = useNavigate();
  return (
    <Wrapper topBarActiveOption={'Events'} active="councellors">
      <div className="flex">
        <div className="w-full overflow-hidden">
          <Table
            mode={mode}
            callAction={(d, action) => {
              setMode('single');
              setAction(action);
              navigate(`/professional-counsellors/${d.uuid}`, {
                state: {
                  itemUuid: d?.uuid,
                },
              });
            }}
          />
          {mode === 'single' && (
            <div className="h-96 w-2/3 bg-gray-50">
              {action === 'view' && <ViewCouncellor />}
            </div>
          )}
        </div>
      </div>
    </Wrapper>
  );
}
